import BookSettings from "./BookSettings";

export default BookSettings;
